module.exports = __webpack_public_path__ + "static/img/chest-active.4d119a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fortune-wheel/chest-active.png
// module id = +8yR
// module chunks = 215